<template>
  <div v-if="!model.$disabled">
    <label :for="'checkbox-' + _uid" v-bind:class="{'state-disabled': isDisabled, 'state-error': model.$error}" class="checkbox">
      <input
        :id="'checkbox-' + _uid"
        ref="input"
        type="checkbox"
        value="true"
        role="checkbox"
        :checked="checked"
        :disabled="isDisabled"
        :name="model.$form.testPath ? model.$path : undefined"
        :aria-invalid="isError"
        :aria-describedby="`err-${_uid} desc-${_uid}`"
        :aria-checked="checked"
        @change="onInput($event)"
        @focus="onFocus($event)"
        @blur="onBlur($event)"
      />

      <i />

      <slot>{{ getTitle }}</slot>

      <w-description :model="model" v-bind="description" :id="'desc-' + _uid">
        <slot name="description" />
      </w-description>

      <w-error :model="model" v-if="showError" :id="'err-' + _uid" />
    </label>
  </div>
</template>

<script>
import modelMixin from '../mixins/modelMixin';

import WError from './error.vue';
import WTooltip from './tooltip.vue';

export default {
  name: 'w-checkbox',
  props: {
    uncheckvalue: {
      type: String
    },
    showError: {
      type: Boolean,
      default: true
    },
    description: {
      type: Object,
      default: () => ({
        value: '',
        tooltip: false,
        htmlContent: false
      }),
      required: false
    }
  },
  mixins: [modelMixin],
  components: {WError, WTooltip},
  data() {
    return {};
  },
  computed: {
    unvalue() {
      if (this.uncheckvalue === undefined) {
        if (this.value === 'true') {
          return 'false';
        } else if (this.value === 'on') {
          return 'off';
        } else {
          return false;
        }
      } else {
        return this.uncheckvalue;
      }
    },
    checked() {
      // let vv = this.$model.$value;
      if (this.$options.hasFocus) {
        return this.$options.localValue;
      }
      switch (this.model.$schema.type) {
        case 'boolean':
          return this.model.$value === 'true';
        case 'array':
          return this.model.$value.indexOf(this.value) > -1;
        default:
          return this.model.$value === this.value;
      }
    }
  },
  mounted() {
    // console.log('checkbox value', JSON.stringify(this.value));
    // console.log('disabled: ', this.disabled);
  },
  methods: {
    onFocus(evt) {
      this.$options.hasFocus = true;
      this.$emit('focus');
      this.model.$hasFocus = true;
    },
    onBlur(evt) {
      this.$options.hasFocus = false;
      this.$emit('blur');
      this.model.$hasFocus = false;
    },
    onInput(evt) {
      this.$options.localValue = evt.target.checked;
      if (evt.target.checked) {
        switch (this.model.$schema.type) {
          case 'boolean':
            this.model.$value = 'true';
            break;
          case 'string':
            this.model.$value = this.value;
            break;
          case 'array':
            const pos = this.model.$value.indexOf(this.$props.value);
            if (pos === -1) {
              this.model.$addRow(this.$props.value);
            }
            break;
        }
      } else {
        switch (this.model.$schema.type) {
          case 'boolean':
            this.model.$value = 'false';
            break;
          case 'string':
            this.model.$value = this.unvalue;
            break;
          case 'array':
            const pos = this.model.$value.indexOf(this.$props.value);
            if (pos > -1) {
              this.model.$removeRow(pos);
            }
            break;
        }
      }
      this.$emit('input');
      this.fieldChanged();
    }
  }
};
</script>
